module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kiwi-personal"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('personal_client')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('personal_addjoin')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('personal_return')))]), _vm._v(" "), _c('button', {
    staticClass: "u-button u-button-primary",
    on: {
      "click": _vm.addNetwork
    }
  }, [_vm._v(_vm._s(_vm.$t('personal_add')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.networks.length > 0) ? _c('a', {
    staticClass: "u-link kiwi-personal-existing-networks",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStateBrowser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('personal_saved')))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f2b459e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/startups/Personal.vue
// module id = 486
// module chunks = 2